module.exports = __webpack_public_path__ + "static/media/jquery.4b1ef75f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/jquery.png
// module id = 127
// module chunks = 0